import { AreaPage, CardGroup } from '@kanos/web-core';
import { createFileRoute } from '@tanstack/react-router';
import { DutyTabs } from '../firm/duty-tabs';
import { MyConfidentialityCard } from '../firm/my-confidentiality-card';
import { ObligationsCard } from '../firm/obligations-card';

export const Route = createFileRoute('/obligations/')({
  component: Obligations,
});

/** The obligations of the firm as the catalogue derived them, with what is still to clarify. */
function Obligations() {
  return (
    <AreaPage title="Pflichten">
      <DutyTabs current="overview" />
      <CardGroup>
        <MyConfidentialityCard />
        <ObligationsCard />
      </CardGroup>
    </AreaPage>
  );
}
